/**
 * Ospiti Page - Page Shell
 * Imports GuestList from features/guests
 * Data fetched via React Query hooks
 */

import { GuestList } from "@/features/ospiti";

export default function Ospiti() {
  return <GuestList />;
}
